import React from "react";
import { Icons } from "../AttributeTypes";
import "./style.css";

const AttributeIcon = ({ attributeType }) => {
	return (
		<div className="d-inline-block">
			<i className={`fa-fw me-2 font-size-1 ${Icons[attributeType]}`}></i>
		</div>
	);
};

AttributeIcon.displayName = "AttributeIcon";

export default AttributeIcon;
